(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventCategoryDeleteController',EventCategoryDeleteController);

    EventCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventCategory'];

    function EventCategoryDeleteController($uibModalInstance, entity, EventCategory) {
        var vm = this;
        vm.eventCategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
